'use strict';

/* jshint node: true, esnext: true, loopfunc: true, undef: true, unused: true */
/* global document, window */

var arrayUtils = require('zero-lang/array');
var isArrayLike = arrayUtils.isArrayLike;
var contains = arrayUtils.contains;
var toArray = arrayUtils.toArray;
var some = arrayUtils.some;
var flatten = arrayUtils.flatten;

var checkType = require('zero-lang/type');
var isString = checkType.isString;

var domUtils = require('./utils');
var testDiv = domUtils.testDiv;
var isDomNode = domUtils.isDomNode;

/*
 * @author      : 绝云（wensen.lws）
 * @description : selector
 * @note        : browser only
 * @note        : MODERN browsers only
 */

var doc = document;
var win = window;
var nodeTypeStr = 'nodeType';
var re_quick = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/; // 匹配快速选择器
var matchesSelector = testDiv.matches || testDiv.webkitMatchesSelector || testDiv.mozMatchesSelector || testDiv.msMatchesSelector || testDiv.oMatchesSelector;
var hasMatchesSelector = matchesSelector && matchesSelector.call(testDiv, 'div');

function normalizeRoot(root) {
    if (!root) {
        return doc;
    }
    if (isString(root)) {
        return query(root)[0];
    }
    if (!root[nodeTypeStr] && isArrayLike(root)) {
        return root[0];
    }
    return root;
}
function query(selector, optRoot) {
    /*
     * description: 选择器
     */
    var root = normalizeRoot(optRoot);
    var match = undefined;

    if (!root || !selector) {
        return [];
    }
    if (selector === win || isDomNode(selector)) {
        return !optRoot || selector !== win && isDomNode(root) && contains(selector, root) ? [selector] : [];
    }
    if (selector.nodeType === 11) {
        // document fragment
        return toArray(selector.childNodes);
    }
    if (selector && isArrayLike(selector)) {
        return flatten(selector);
    }

    // 简单查询使用快速查询方法 {
    if (isString(selector) && (match = re_quick.exec(selector))) {
        if (match[1]) {
            return [root.getElementById(match[1])];
        } else if (match[2]) {
            return toArray(root.getElementsByTagName(match[2]));
        } else if (match[3]) {
            return toArray(root.getElementsByClassName(match[3]));
        }
    }
    // }
    if (selector && (selector.document || selector[nodeTypeStr] && selector[nodeTypeStr] === 9)) {
        return !optRoot ? [selector] : [];
    }
    return toArray(root.querySelectorAll(selector));
}
function queryOne(selector, optRoot) {
    return query(selector, optRoot)[0];
}

function match(element, selector) {
    /*
     * @matches selector
     */
    if (hasMatchesSelector) {
        return matchesSelector.call(element, selector);
    }
    var parentElem = element.parentNode;
    var nodes = undefined;

    // if the element is an orphan, and the browser doesn't support matching
    // orphans, append it to a documentFragment
    if (!parentElem && !hasMatchesSelector) {
        parentElem = document.createDocumentFragment();
        parentElem.appendChild(element);
    }
    // from the parent element's context, get all nodes that match the selector
    nodes = query(selector, parentElem);

    // since support for `matches()` is missing, we need to check to see if
    // any of the nodes returned by our query match the given element
    return some(nodes, function (node) {
        return node === element;
    });
}

module.exports = {
    all: query,
    one: queryOne,
    match: match
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/zero-dom/query.js
 ** module id = 54
 ** module chunks = 0
 **/